import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { Customer } from './models/customer';
import { resultFrom } from './result';

@Injectable({ providedIn: 'root' })
export class AuthService {
    private refreshTokenTimeout: any;
    // private userSubject: BehaviorSubject<Customer | null>;
    loggedInCustomer = signal<Customer | null>(null);

    constructor(private http: HttpClient, private router: Router) {}

    async login(email: string, password: string) {
        const result = await resultFrom(
            this.http.post<Customer>(`${environment.serviceUrl}/api/account/authenticate`, { email, password }, { withCredentials: true })
        );
        if (result.isSuccess) this.setCustomer(new Customer(result.value!));
        return result;
    }

    private setCustomer(customer: Customer) {
        this.loggedInCustomer.set(customer);
        this.startRefreshTokenTimer();
        return customer;
    }

    private startRefreshTokenTimer() {
        const jwtToken = this.loggedInCustomer()?.jwtToken;
        if (!jwtToken) return;

        // parse json object from base64 encoded jwt token
        const token = JSON.parse(atob(jwtToken.split('.')[1]));

        // set a timeout to refresh the token every fifteen minutes
        const timeout = 15 * 60 * 1000;
        this.refreshTokenTimeout = setTimeout(async () => await this.refreshToken(), timeout);
    }

    async refreshToken() {
        const result = await resultFrom(
            this.http.post<Customer>(`${environment.serviceUrl}/api/account/refresh-token`, {}, { withCredentials: true })
        );
        if (!result.value) return null;
        this.setCustomer(new Customer(result.value));
        return result;
    }

    async logout() {
        await resultFrom(this.http.post<any>(`${environment.serviceUrl}/api/account/revoke-token`, {}, { withCredentials: true }));
        this.stopRefreshTokenTimer();
        this.loggedInCustomer.set(null);
    }

    async register(customer: Customer) {
        const result = await resultFrom(
            this.http.post<Customer>(`${environment.serviceUrl}/api/account/register`, customer, { withCredentials: true })
        );
        if (result.isSuccess) this.setCustomer(new Customer(result.value!));
        return result;
    }

    private stopRefreshTokenTimer() {
        clearTimeout(this.refreshTokenTimeout);
    }
}
